import { cache, } from "./cache";
import { latestPriceEth, } from "./latestPriceEth";
import { bracketRate, } from "./bracketRate";



/**
 * Gets the current price of BRKT in USD by multiplying the BRKT/ETH rate by the ETH/USD price
 * Uses a cached value if available and not expired
 * @returns Promise resolving to the current BRKT price in USD as a number
 */
export const bracketPrice = async (): Promise<number> => {
	const now = new Date().getTime();
	const {
		time,
		value,
		since,
	} = cache.bracket_price;
	if(since > now - time) {
		return value;
	}
  const next = (await bracketRate()) * (await latestPriceEth());
  if(typeof next === "number") {
    cache.bracket_price.since = new Date().getTime();
    cache.bracket_price.value = next;
    return cache.bracket_price.value;
  }
  console.warn("bracketPrice failed to gain a valid value");
	return next;
}
